"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADVISOR_HAU = void 0;
/**
 * Run on 6/3/2025:
   select max(ct) from
    (select
        dayname(CREATED_AT)||' '||hour(CREATED_AT),
        count(*)/6 as ct
    from AVEN_ADVISOR_VISIT
    where CREATED_AT > current_date - interval '6 weeks'
    group by 1)
 */
exports.ADVISOR_HAU = 438;
